import { Component, HostListener, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EDeviceModel } from "src/app/conf/device-models";
import { Device } from "src/app/model/device";
import { StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";

@Component({
	selector: 'app-notifications-device-tab',
	templateUrl: './notifications-device-tab.component.html',
	providers: [],
})

export class NotificationsDeviceTabComponent implements OnInit {
	@Input() device: Device;
	@Input() userCurrentlyOwner: boolean;

	screenWidth: any;

	constructor(
		private translate: TranslateService
	) {}

	ngOnInit(): void {
		this.onResize();
	}

	disableManeuvers(): boolean {
		if (this.device.ModelId === EDeviceModel.MultiIO ||
			this.device.ModelId === EDeviceModel.IORS485 ||
			this.device.ModelId === EDeviceModel.GEN_IORS485 ||
			this.device.ModelId === EDeviceModel.RBE4 ||
			this.device.ModelId === EDeviceModel.RBE4030 ||
			this.device.ModelId === EDeviceModel.RBE4230 ||
			this.device.ModelId === EDeviceModel.GEN_RBE4 ||
			this.device.ModelId === EDeviceModel.RBE24 ||
			this.device.ModelId === EDeviceModel.RBE230 ||
			this.device.ModelId === EDeviceModel.RBE24230 ||
			this.device.ModelId === EDeviceModel.GEN_RBE24230) {
			return true;
		}
		return false;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}